import script from "./ErrorView.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorView.vue?vue&type=script&setup=true&lang=ts"

import "./ErrorView.vue?vue&type=style&index=0&id=7f8878c8&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f8878c8"]])

export default __exports__